import {
  CLEAR_NOTIFY,
  NOTIFICATION_CHANGED,
  MIGRATION_PROGRESS
} from '../actions/content-alert-actions'

const initialState = {
  message           : '',
  button_text       : 'Okay',
  notification_type : 'warning',
  on_click          : null
}

export default function contentAlert(state = initialState, action = {}) {
  switch (action.type) {
    case NOTIFICATION_CHANGED:
      return {
        ...state,
        ...action
      }
    default:
      return state;
  }
}
